// Based on:
// https://codeburst.io/react-authentication-with-twitter-google-facebook-and-github-862d59583105
import { g } from "analytics";
import { BACKEND_API } from "api/api";
import { t } from "i18next";
import { clog } from "log";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { logIn } from "store/actions";
import store from "store/store";
import { Toast } from "toast";
import { isIEOrEdge } from "utils";
export function loginProviderIcon(provider) {
    if (provider === "facebook") {
        return "fab fa-facebook-f";
    }
    else if (provider === "code") {
        return "fas fa-key";
    }
    return "fab fa-" + provider;
}
export function loginProviderDisplayName(provider) {
    return provider !== "code" ? provider.capitalise() : "access code";
}
export class LoginButton extends React.Component {
    constructor(props) {
        super(props);
        this.render = () => {
            const providerName = this.props.providerName;
            return React.createElement("button", { className: `ui-button mx-auto mt-2 ${providerName}`, onClick: () => this.onButtonClick() },
                React.createElement("i", { className: `mr-2 ${loginProviderIcon(providerName)}` }),
                React.createElement(SignInLabel, { providerName: providerName }));
        };
        this.state = {};
        let self = this;
        this.messageHandler = (ev) => {
            // Filter any messages that are not from our API,
            // don't relate to this provider or while
            // the button is not active.
            if (ev.origin != BACKEND_API)
                return;
            if (!this.props.active)
                return;
            let response = ev.data;
            if (response.provider != this.props.providerName)
                return;
            self.onReceiveLoginResponse(ev.data);
        };
    }
    componentDidMount() {
        window.addEventListener("message", this.messageHandler, true);
    }
    componentWillUnmount() {
        window.removeEventListener("message", this.messageHandler, true);
    }
    onReceiveLoginResponse(response) {
        if (response.type == "success") {
            // Successfully signed in.
            store.dispatch(logIn({
                provider: this.props.providerName,
                jwtToken: response.jwt,
                user: response.user,
                firstTimeLogin: response.firstTimeLogin,
                tier: response.tier,
            }));
            this.props.onSuccess(response.jwt, response.tier);
            g("SignIn", this.props.providerName);
        }
        else if (response.type == "error") {
            Toast.error(t("login.error.description"), t("login.error.title"));
            throw new Error("Failed to sign in: Error");
        }
        else {
            Toast.error(t("login.error.unknown"), t("login.error.title"));
            throw new Error("Failed to sign in: Unknown response.");
        }
    }
    onButtonClick() {
        let provider = this.props.providerName;
        let loginUrl = `${BACKEND_API}/auth/${provider}`;
        if (this.props.onClick)
            this.props.onClick();
        let width = 800;
        let height = 660;
        const x = window.outerWidth / 2 + window.screenX - (width / 2);
        const y = window.screenY + 20;
        // IE/EDGE have a problem with permission denied, so use a login_redirect.html.
        let url = isIEOrEdge() ? `safe_redirect.html?to=${loginUrl}` : loginUrl;
        let loginWindow = window.open(url, '', `toolbar=no, location=no, directories=no, status=no, menubar=no,
            scrollbars=no, resizable=no, copyhistory=no
            width=${width} height=${height} top=${y} left=${x}
            `);
        loginWindow.onunload = () => {
            clog("Log in window closed.");
        };
    }
}
const SignInLabel = ({ providerName }) => {
    const { t } = useTranslation();
    return React.createElement("span", null, t('login.sign_in_with', { provider: t(loginProviderDisplayName(providerName)) }));
};
